import React from 'react'

function CancellationAndRefundPolicy() {
  return (
     <div className="container-fluid nav-margin">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <h3 className='my-4 red-t'>Cancellation & Refund Policy</h3>
                    <p className='my-4'>No cancellations & Refunds are entertained</p>
                </div>
            </div>
        </div>
     </div>
  )
}

export default CancellationAndRefundPolicy